import type { HiredEquipmentSessionStatus, HiredEquipmentSessionSubmission } from '../types';

const KEY = 'wrap.hiredEquipment.sessionSubmissions';

export function readSessionSubmissions(): HiredEquipmentSessionSubmission[] {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as HiredEquipmentSessionSubmission[]) : [];
  } catch {
    return [];
  }
}

export function persistSessionSubmission(submission: HiredEquipmentSessionSubmission): void {
  try {
    const next = [submission, ...readSessionSubmissions()];
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore quota
  }
}

export function formStatusToSessionStatus(status: string | null | undefined): HiredEquipmentSessionStatus {
  const normalized = (status || '').toLowerCase();
  if (normalized === 'need revisions') return 'need_revisions';
  if (normalized === 'declined') return 'declined';
  if (normalized === 'approved') return 'approved';
  return 'pending';
}

export function updateSessionSubmissionStatus(
  formId: string,
  status: HiredEquipmentSessionStatus,
): void {
  try {
    const next = readSessionSubmissions().map((row) =>
      row.formId === formId ? { ...row, status } : row,
    );
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore quota
  }
}
